import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class RoleAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/role', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/role/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (role, success, failure) => {
    fetch(Config.app.link + 'api/role', new Header('POST', role))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/role/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default RoleAPI;